// src/components/HomeBrandBanner.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const HomeBrandBanner = ({ className = "" }) => {
  return (
    <div className={`w-full max-w-4xl mx-auto my-12 px-4 ${className}`}>
      <Link
        to="/"
        className="group relative flex items-center gap-4 p-4 sm:p-5 rounded-2xl bg-[#0d0d0f]/90 border-2 border-[#F2B135] hover:border-[#ffc65c] shadow-[0_10px_30px_rgba(242,177,53,0.15)] hover:shadow-[0_15px_40px_rgba(242,177,53,0.25)] transition-all duration-300 transform hover:-translate-y-1 block"
      >
        {/* Favicon Box */}
        <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-white border border-[#F2B135] flex items-center justify-center p-2 shadow-inner group-hover:scale-105 transition-transform duration-300">
          <img
            src="/favicon.png"
            alt="Rojrztech Favicon"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Brand Name & Callout */}
        <div className="flex flex-col">
          <span
            className="text-[#F2B135] group-hover:text-[#ffca58] font-black text-xl sm:text-2xl tracking-tight transition-colors font-display"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Rojrztech
          </span>
          <span className="text-white/60 text-xs sm:text-sm font-medium">
            Click here to return to Home Page
          </span>
        </div>

        {/* Subtle right arrow indicator */}
        <div className="ml-auto w-8 h-8 rounded-full border border-[#F2B135]/40 flex items-center justify-center text-[#F2B135] group-hover:bg-[#F2B135] group-hover:text-black transition-all">
          →
        </div>
      </Link>
    </div>
  );
};

export default HomeBrandBanner;
